// Cart Drawer Personal - UI-specific functions for cart drawer

// UI-specific function to open cart drawer
function openCart(shouldDelay = false) {
  try {
    const cartDrawer = document.getElementById('cart-drawer-personal');
    if (cartDrawer) {
      const openCartAction = () => {
        cartDrawer.classList.add('open');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
        
        // Update cart content when opened with animation
        updateCartDrawerContent(true);
        
        // Check for discount and auto-open discount section if first time
        checkDiscountAndFirstOpen();
        

      };
      
      if (shouldDelay) {
        setTimeout(openCartAction, 1000); // 0.3s delay
      } else {
        openCartAction();
      }
    } else {
      console.warn('Cart drawer element not found');
    }
  } catch (error) {
    console.error('❌ Error opening cart drawer:', error);
  }
}

// UI-specific function to close cart drawer
function closeCart() {
  try {
    const cartDrawer = document.getElementById('cart-drawer-personal');
    if (cartDrawer) {
      cartDrawer.classList.remove('open');
      
      // Wait for animation to complete before restoring scroll
      setTimeout(() => {
        document.body.style.overflow = ''; // Restore background scrolling
      }, 400); // Match the CSS transition duration
      

    }
  } catch (error) {
    console.error('❌ Error closing cart drawer:', error);
  }
}

// UI-specific function to update cart drawer content
async function updateCartDrawerContent(shouldAnimate = false) {
  try {
    const currentSupplementCart = JSON.parse(localStorage.getItem("currentSupplementCart")) || {};
    const supplements = Object.keys(currentSupplementCart);
    
    const cartItemsContainer = document.getElementById('cart-items-container');
    const cartEmptyState = document.getElementById('cart-empty-state');
    const cartSupplementList = document.getElementById('cart-supplement-list');
    
    if (supplements.length === 0) {
      // Show empty state
      if (cartEmptyState) cartEmptyState.style.display = 'flex';
      if (cartItemsContainer) cartItemsContainer.style.display = 'none';
    } else {
      // Show cart items
      if (cartEmptyState) cartEmptyState.style.display = 'none';
      if (cartItemsContainer) cartItemsContainer.style.display = 'block';
      
      // Update supplement list
      if (cartSupplementList) {
        cartSupplementList.innerHTML = '';
        
        supplements.forEach(supplementName => {
          const supplementData = fetchDataSupplement[supplementName];
          if (supplementData) {
            const supplementItem = createSupplementCartItem(supplementName, supplementData, shouldAnimate);
            cartSupplementList.appendChild(supplementItem);
          }
        });
      }
    }
    
    // Update add more supplements list
    updateAddMoreSupplementsList();
    
    // Check and display applied discounts from localStorage
    displayAppliedDiscountsFromStorage();
    
    // Update cart summary and shipping progress
    updateCartSummary();
    await updateShippingProgress();
    
  } catch (error) {
    console.error('❌ Error updating cart drawer content:', error);
  }
}

// UI-specific function to create supplement cart item
function createSupplementCartItem(supplementName, supplementData, shouldAnimate = false) {
  const item = document.createElement('div');
  item.className = shouldAnimate ? 'cdp-cart-supplement-item slide-in' : 'cdp-cart-supplement-item';
  
  // Get supplement image from global data
  let supplementImage = 'https://via.placeholder.com/48';
  if (typeof pills_floating !== 'undefined' && pills_floating[supplementName]) {
    supplementImage = pills_floating[supplementName];
  } else if (supplementData && supplementData.image) {
    supplementImage = supplementData.image;
  }
  
  // Get supplement dosage info
  let dosageInfo = 'Health supplement';
  if (typeof doses !== 'undefined' && typeof unit !== 'undefined' && typeof numberOfCapsules !== 'undefined') {
    if (doses[supplementName] && unit[supplementName] && numberOfCapsules[supplementName]) {
      dosageInfo = `${doses[supplementName]}${unit[supplementName]} · ${numberOfCapsules[supplementName]}`;
    }
  }
  
  // Get supplement benefits/tags
  let benefitsText = 'Health supplement';
  if (typeof supplementToGoalsL1L2_very_short !== 'undefined' && supplementToGoalsL1L2_very_short[supplementName]) {
    benefitsText = supplementToGoalsL1L2_very_short[supplementName].slice(0, 2).join(', ');
  } else if (supplementData && supplementData.benefits) {
    benefitsText = supplementData.benefits.slice(0, 2).join(', ');
  }
  
  // Get current currency and price
  let currencyCode = 'SGD';
  if (window.Shopify && Shopify.currency && Shopify.currency.active) {
    currencyCode = Shopify.currency.active;
  }
  
  const price = getFormattedPrice(supplementName, false, currencyCode);
  const formattedPrice = formatWithCurrency(window.Shopify?.currency, price.value.toFixed(2));

  item.innerHTML = `
    <div class="cdp-supplement-left-container">
      <img src="${supplementImage}" 
          alt="${supplementName}" 
          class="cdp-supplement-image">
      
      <div class="cdp-supplement-info">
        <h4 class="cdp-supplement-name body-semibold-black font-16px">${supplementName}</h4>
        <p class="cdp-supplement-dosage body-medium-grey font-14px">30 servings</p>
        <p class="cdp-supplement-benefits body-medium-lightgrey font-14px">${dosageInfo}</p>
      </div>
    </div>
    
    <div class="cdp-supplement-actions">
      <button class="cdp-remove-supplement" onclick="removeSupplementFromCartDrawer('${supplementName}')">
        <svg class="cross-icon" viewBox="0 0 24 24">
          <path d="M18 6L6 18M6 6l12 12" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"/>
        </svg>
      </button>
      
      <div class="cdp-supplement-price">
        <div class="cdp-price-amount body-semibold-black font-18px">${formattedPrice}</div>
        <div class="cdp-price-period body-medium-lightgrey font-10px">per month</div>
      </div>
    </div>
  `;
  
  return item;
}

// UI-specific function to remove supplement from cart drawer
function removeSupplementFromCartDrawer(supplementName) {
  try {
    const removeButton = event.target.closest('.cdp-remove-supplement');
    if (removeButton) {
      removeButton.disabled = true;
      removeButton.innerHTML = '<div style="display:block !important; width: 18px; height: 18px; border: 2px solid #ccc; border-top: 2px solid #1d1d1d; border-radius: 50%; animation: spin 1s linear infinite;"></div>';
    }
    
    // Set up one-time event listener to wait for cart change
    const handleCartRemoval = () => {

      
      // Update cart drawer content without animation
      updateCartDrawerContent(false);
            
      // Remove this event listener after handling
      window.removeEventListener('cartChangedDelayed', handleCartRemoval);
    };
    
    // Add event listener for cart change
    window.addEventListener('cartChangedDelayed', handleCartRemoval);
    
    // Trigger removal (don't await - let the event handle the UI update)
    globalRemoveSupplementFromCart(supplementName).catch(error => {
      console.error('❌ Error removing supplement from cart drawer:', error);
      
      // Remove the event listener on error
      window.removeEventListener('cartChangedDelayed', handleCartRemoval);
      
      // Reset button state on error
      const removeButton = event.target.closest('.cdp-remove-supplement');
      if (removeButton) {
        removeButton.disabled = false;
        removeButton.innerHTML = `
          <svg class="cross-icon" viewBox="0 0 24 24">
            <path d="M18 6L6 18M6 6l12 12" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"/>
          </svg>
        `;
      }
    });
    
  } catch (error) {
    console.error('❌ Error setting up supplement removal:', error);
  }
}

// UI-specific function to apply discount from cart drawer
async function applyCartDiscount() {
  try {
    const discountInput = document.getElementById('cart-discount-input');
    const applyButton = document.getElementById('cart-apply-discount');
    
    if (!discountInput || !applyButton) return;
    
    const discountCode = discountInput.value.trim();
    if (!discountCode) return;
    
    // Apply discount using global function
    const result = await globalAddDiscount(discountCode, applyButton, "Checking...", "Applied", "Invalid", "Applied");
    
    if (result.success) {
      // Clear input on success
      discountInput.value = '';
      
      // Update applied discounts display
      updateAppliedDiscounts();
      
      // Show success message if discount was replaced
      if (result.replaced) {
        showDiscountSuccess(`Discount upgraded! Replaced ${result.replaced} with ${discountCode}`);
      }
    } else {
      // Handle different error types with specific messages
      if (result.error === 'CANNOT_COMBINE') {
        showDiscountError(result.message, 'warning'); // Different styling for combination errors
      } else {
        showDiscountError(result.message, 'error'); // Standard error styling for invalid codes
      }
    }
    
    // Always refresh everything after discount action
    updateCartSummary();
    await updateShippingProgress();
    
  } catch (error) {
    console.error('❌ Error applying cart discount:', error);
  }
}

// UI-specific function to remove applied discount
async function removeAppliedDiscount(discountCode, buttonElement) {
  try {
    // Call global remove function
    const result = await globalRemoveAppliedDiscount(discountCode);
    
    if (result.success) {
      // Remove from UI
      const discountItem = buttonElement.closest('.cdp-applied-discount-item');
      if (discountItem) {
        discountItem.remove();
      }
      
      // Recompute discount content height after removal
      recomputeDiscountContentHeight();
      
      // Update discount count bubble
      updateDiscountCountBubble();
      
      // Update the display
      updateCartSummary();
      await updateShippingProgress();
    }
    
  } catch (error) {
    console.error('❌ Error removing applied discount:', error);
  }
}

// UI-specific function to go to checkout from cart drawer
async function goToCheckout() {
  try {
    const checkoutButton = document.querySelector('.cdp-cart-checkout-btn');
    const checkoutBtnText = document.getElementById('checkout-btn-text');
    
    // Call global checkout function with button element and processing text
    const result = await globalGoToCheckout({
      onSuccess: () => {

      },
      onError: (error) => {
        // Show specific error message
        const errorMessage = error.message || 'There was an error processing your checkout. Please try again.';
        alert(errorMessage);
        console.error('Checkout error details:', error);
      }
    }, checkoutButton, 'Processing...');
    
  } catch (error) {
    console.error('❌ Error during checkout:', error);
    alert('There was an error processing your checkout. Please try again.');
  }
}

// UI-specific function to display applied discounts from localStorage
function displayAppliedDiscountsFromStorage() {
  try {
    // Use the new updateAppliedDiscounts function
    updateAppliedDiscounts();
    
  } catch (error) {
    console.error('❌ Error displaying applied discounts:', error);
  }
}

// UI-specific function to update cart summary
function updateCartSummary() {
  try {
    let currencyCode = "SGD";
    if (window.Shopify?.currency?.active) {
      currencyCode = Shopify.currency.active;
    }
    
    // Get cart calculations from global function
    const cartCalculations = globalCalculateCartTotals();
    
    // Get current supplement cart to count items
    const currentSupplementCart = JSON.parse(localStorage.getItem("currentSupplementCart")) || {};
    const supplementCount = Object.keys(currentSupplementCart).length;
    
    // Update DOM elements
    const cartSubtotalLabel = document.getElementById('cart-subtotal-label');
    const cartSubtotal = document.getElementById('cart-subtotal');
    const cartOriginalSubtotal = document.getElementById('cart-original-subtotal');
    
    // Update subtotal label with item count
    if (cartSubtotalLabel) {
      cartSubtotalLabel.textContent = `Subtotal (${supplementCount} item${supplementCount !== 1 ? 's' : ''})`;
    }
    
    // Update cart item count in header
    updateCartItemCount(supplementCount);
    
    // Update subtotal prices
    if (cartSubtotal) {
      const subtotal = cartCalculations.subtotal -  cartCalculations.totalDiscountAmount;
      cartSubtotal.textContent = formatWithCurrency(window.Shopify?.currency, subtotal.toFixed(2));
    }
    
    // Show original price if there's a discount
    if (cartOriginalSubtotal) {
      if (cartCalculations.totalDiscountAmount > 0) {
        const originalSubtotal = cartCalculations.subtotal;
        cartOriginalSubtotal.textContent = formatWithCurrency(window.Shopify?.currency, originalSubtotal.toFixed(2));
        cartOriginalSubtotal.style.display = 'block';
      } else {
        cartOriginalSubtotal.style.display = 'none';
      }
    }
    

    
  } catch (error) {
    console.error('❌ Error updating cart summary:', error);
  }
}

// UI-specific function to update shipping progress
async function updateShippingProgress() {
  try {
    let currencyCode = "SGD";
    if (window.Shopify?.currency?.active) {
      currencyCode = Shopify.currency.active;
    }
    
    // Get shipping calculations from global function
    const shippingCalculations = globalCalculateShippingProgress(currencyCode);
    
    const progressElement = document.getElementById('shipping-progress-fill');
    const progressTextElement = document.getElementById('shipping-progress-text');
    const amountNeededElement = document.getElementById('amount-needed-shipping');
    
    // Update progress bar
    if (progressElement) {
      progressElement.style.width = `${shippingCalculations.progressPercentage}%`;
    }
    
    // Update progress text
    if (progressTextElement) {
      if (shippingCalculations.freeShippingAchieved) {
        progressTextElement.innerHTML = `<span>You've unlocked FREE shipping!</span>`;
      } else {
        progressTextElement.innerHTML = `Spend <span id="amount-needed-shipping">${shippingCalculations.amountNeededFormatted}</span> to unlock FREE shipping!`;
      }
    }
    
    if (amountNeededElement && !shippingCalculations.freeShippingAchieved) {
      amountNeededElement.textContent = shippingCalculations.amountNeededFormatted;
    }
    
  } catch (error) {
    console.error('❌ Error updating shipping progress:', error);
  }
}

// UI-specific helper functions for messages
function showDiscountError(message, type = 'error') {
  // Create or update error message element
  let errorElement = document.getElementById('discount-error-message');
  
  if (!errorElement) {
    errorElement = document.createElement('div');
    errorElement.id = 'discount-error-message';
    
    const discountSection = document.querySelector('.cdp-discount-section');
    if (discountSection) {
      discountSection.appendChild(errorElement);
    }
  }
  
  // Set different styling based on error type
  if (type === 'warning') {
    errorElement.className = 'cdp-discount-warning';
  } else {
    errorElement.className = 'cdp-discount-error';
  }
  
  errorElement.textContent = message;
  errorElement.style.display = 'block';
  
  // Auto-hide error after 6 seconds for warnings, 4 seconds for errors
  const hideTimeout = type === 'warning' ? 6000 : 4000;
  setTimeout(() => {
    if (errorElement) {
      errorElement.style.display = 'none';
    }
  }, hideTimeout);
}

function showDiscountSuccess(message) {
  // Create or update success message element
  let successElement = document.getElementById('discount-success-message');
  
  if (!successElement) {
    successElement = document.createElement('div');
    successElement.id = 'discount-success-message';
    successElement.className = 'cdp-discount-success';
    
    const discountSection = document.querySelector('.cdp-discount-section');
    if (discountSection) {
      discountSection.appendChild(successElement);
    }
  }
  
  successElement.textContent = message;
  successElement.style.display = 'block';
  
  // Auto-hide success after 3 seconds
  setTimeout(() => {
    if (successElement) {
      successElement.style.display = 'none';
    }
  }, 3000);
}

// UI-specific function to toggle discount section accordion
function toggleDiscountSection(withAnimation = true) {
  try {
    const discountSection = document.querySelector('.cdp-discount-section');
    const discountContent = document.querySelector('.cdp-discount-content');
    const chevronToUp = discountSection?.querySelector('.chevron-to-up');
    const chevronToDown = discountSection?.querySelector('.chevron-to-down');
    
    if (!discountSection || !discountContent) return;
    
    const isActive = discountSection.classList.contains('active');
    
    if (isActive) {
      // Close
      discountSection.classList.remove('active');
      discountContent.style.maxHeight = '0px';
      if (chevronToDown) chevronToDown.beginElement();
    } else {
      // Open
      discountSection.classList.add('active');
      discountContent.style.maxHeight = discountContent.scrollHeight + 'px';
      if (chevronToUp) chevronToUp.beginElement();
      
      // If animation is requested, trigger confetti after section is fully open
      if (withAnimation) {
        // Wait 0.8s total (0.3s for opening animation + 0.5s delay after fully open)
        setTimeout(() => {
          triggerDiscountConfetti();
        }, 800);
      }
    }
    
  } catch (error) {
    console.error('❌ Error toggling discount section:', error);
  }
}

// UI-specific function to trigger confetti animation from discount item
function triggerDiscountConfetti() {
  try {
    // Find the first applied discount item
    const firstDiscountItem = document.querySelector('.cdp-applied-discount-item');
    
    if (!firstDiscountItem) {

      return;
    }
    
    // Get the center position of the discount item
    const rect = firstDiscountItem.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    
    // Create confetti container
    const confettiContainer = document.createElement('div');
    confettiContainer.style.position = 'fixed';
    confettiContainer.style.top = '0';
    confettiContainer.style.left = '0';
    confettiContainer.style.width = '100%';
    confettiContainer.style.height = '100%';
    confettiContainer.style.minHeight = '100vh';
    confettiContainer.style.pointerEvents = 'none';
    confettiContainer.style.zIndex = '9999';
    confettiContainer.style.visibility = 'visible';
    confettiContainer.style.display = 'block';
    confettiContainer.id = 'discount-confetti-container';
    document.body.appendChild(confettiContainer);
    
    // Confetti colors
    const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2'];
    
    // Create confetti particles
    const particleCount = 50;
    const particles = [];
    
    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      const size = Math.random() * 8 + 4; // 4-12px
      const color = colors[Math.floor(Math.random() * colors.length)];
      
      particle.style.position = 'absolute';
      particle.style.width = size + 'px';
      particle.style.height = size + 'px';
      particle.style.backgroundColor = color;
      particle.style.borderRadius = Math.random() > 0.5 ? '50%' : '0%';
      particle.style.left = centerX + 'px';
      particle.style.top = centerY + 'px';
      particle.style.opacity = '1';
      particle.style.setProperty('display', 'block', 'important');
      particle.style.transform = 'translate(-50%, -50%)';
      particle.style.boxSizing = 'border-box';
      particle.style.pointerEvents = 'none';
      particle.style.visibility = 'visible';
      particle.style.overflow = 'visible';
      
      confettiContainer.appendChild(particle);
      
      // Random velocity and rotation
      const angle = (Math.PI * 2 * Math.random());
      const velocity = Math.random() * 300 + 200; // 200-500px/s
      const vx = Math.cos(angle) * velocity;
      const vy = Math.sin(angle) * velocity;
      const rotation = Math.random() * 360;
      const rotationSpeed = (Math.random() - 0.5) * 720; // -360 to 360 deg/s
      
      particles.push({
        element: particle,
        x: centerX,
        y: centerY,
        vx: vx,
        vy: vy,
        rotation: rotation,
        rotationSpeed: rotationSpeed,
        gravity: 800, // pixels per second squared
        life: 0,
        maxLife: 2 // 2 seconds
      });
    }
    
    // Animate particles
    let lastTime = Date.now();
    const animate = () => {
      const currentTime = Date.now();
      const deltaTime = (currentTime - lastTime) / 1000; // in seconds
      lastTime = currentTime;
      
      let allDone = true;
      
      particles.forEach((particle) => {
        if (particle.life >= particle.maxLife) {
          return; // Skip if particle is done
        }
        
        allDone = false;
        
        // Update physics
        particle.vy += particle.gravity * deltaTime; // Apply gravity
        particle.x += particle.vx * deltaTime;
        particle.y += particle.vy * deltaTime;
        particle.rotation += particle.rotationSpeed * deltaTime;
        particle.life += deltaTime;
        
        // Update position and rotation
        particle.element.style.left = particle.x + 'px';
        particle.element.style.top = particle.y + 'px';
        particle.element.style.transform = `translate(-50%, -50%) rotate(${particle.rotation}deg)`;
        
        // Fade out as particle ages
        const fadeStart = particle.maxLife * 0.6; // Start fading at 60% of life
        if (particle.life > fadeStart) {
          const fadeProgress = (particle.life - fadeStart) / (particle.maxLife - fadeStart);
          particle.element.style.opacity = (1 - fadeProgress).toString();
        }
      });
      
      if (allDone) {
        // Remove confetti container
        if (confettiContainer.parentNode) {
         confettiContainer.parentNode.removeChild(confettiContainer);
        }
        
      } else {
        // Continue animation
        requestAnimationFrame(animate);
      }
    };
    
    // Start animation
    requestAnimationFrame(animate);
    
  
    
  } catch (error) {
    console.error('❌ Error triggering confetti animation:', error);
  }
}

// UI-specific function to update add more supplements list
function updateAddMoreSupplementsList() {
  try {
    const addMoreList = document.getElementById('add-more-supplements-list');
    if (!addMoreList) return;
    
    const currentSupplementCart = JSON.parse(localStorage.getItem("currentSupplementCart")) || {};
    const currentSupplements = Object.keys(currentSupplementCart);
    
    // Get all available supplements (excluding those already in cart)
    const availableSupplements = [];
    if (typeof fetchDataSupplement !== 'undefined') {
      Object.keys(fetchDataSupplement).forEach(supplementName => {
        if (!currentSupplements.includes(supplementName)) {
          availableSupplements.push(supplementName);
        }
      });
    }
    
    // Clear existing list
    addMoreList.innerHTML = '';
    
    // Add supplement cards
    availableSupplements.slice(0, 10).forEach(supplementName => { // Limit to 10 for performance
      const supplementData = fetchDataSupplement[supplementName];
      if (supplementData) {
        const supplementCard = createAddMoreSupplementCard(supplementName, supplementData);
        addMoreList.appendChild(supplementCard);
      }
    });
    
  } catch (error) {
    console.error('❌ Error updating add more supplements list:', error);
  }
}

// UI-specific function to create add more supplement card
function createAddMoreSupplementCard(supplementName, supplementData) {
  const card = document.createElement('div');
  card.className = 'cdp-add-more-item card-internal-shadow';
  
  // Get supplement image
  let supplementImage = 'https://via.placeholder.com/24';
  
  if (typeof pills_floating !== 'undefined' && pills_floating[supplementName]) {
    supplementImage = pills_floating[supplementName];
  } else if (supplementData && supplementData.image) {
    supplementImage = supplementData.image;
  }
  
  // Get current currency
  let currencyCode = 'SGD';
  if (window.Shopify && Shopify.currency && Shopify.currency.active) {
    currencyCode = Shopify.currency.active;
  }
  
  // Get supplement price using the same logic as supplement grid
  const price = getFormattedPrice(supplementName, false, currencyCode);
  
  card.innerHTML = `
    <img src="${supplementImage}" alt="${supplementName}" class="cdp-add-more-item-icon">
    <div class="cdp-add-more-item-info">
      <h4 class="cdp-add-more-item-name body-semibold-black font-16px">${supplementName}</h4>
      <div class="cdp-add-more-item-price body-semibold-black font-16px">
        <span class="currency">${price.prefix}</span>
        <span class="amount">${price.value}</span>
        <span class="cents ${currencyCode}" style="display: ${currencyCode === 'IDR' ? 'inline' : 'none'}">${price.suffix}</span>
      </div>
    </div>
    <button class="cdp-add-more-item-btn secondary-button" onclick="addSupplementToCartFromDrawer('${supplementName}')">
      + Add
    </button>
  `;
  
  return card;
}

// UI-specific function to add supplement to cart from drawer
async function addSupplementToCartFromDrawer(supplementName) {
  let addButton = null;
  
  try {
    addButton = event.target;
    if (addButton) {
      addButton.disabled = true;
      // Show spinning animation instead of text
      addButton.innerHTML = '<div style="display:block !important; width: 16px; height: 16px; border: 2px solid #ccc; border-top: 2px solid #1d1d1d; border-radius: 50%; animation: spin 1s linear infinite;"></div>';
    }
    
    // Set up one-time event listener to wait for cart change
    const handleCartAddition = () => {
     
      
      // Update cart drawer content without animation
      updateCartDrawerContent(false);
      
      // Reset button state
      if (addButton) {
        addButton.disabled = false;
        addButton.innerHTML = '+ Add';
      }
      
      // Remove this event listener after handling
      window.removeEventListener('cartChangedDelayed', handleCartAddition);
    };
    
    // Add event listener for cart change
    window.addEventListener('cartChangedDelayed', handleCartAddition);
    
    // Call global add function (doesn't return a result object)
    await globalAddSupplementToCart(
      supplementName,
      null,
      "Adding...",
      "Added to Stack",
      "addToCartFromDrawer",
      false // Don't open cart since we're already in the drawer
    );
    
  } catch (error) {
    console.error('❌ Error adding supplement to cart from drawer:', error);
    
    // Remove the event listener on error
    window.removeEventListener('cartChangedDelayed', handleCartAddition);
    
    // Reset button state on error
    if (addButton) {
      addButton.disabled = false;
      addButton.innerHTML = '+ Add';
    }
  }
}

// UI-specific function to scroll supplements horizontally
function scrollSupplements(direction) {
  try {
    const addMoreList = document.getElementById('add-more-supplements-list');
    if (!addMoreList) return;
    
    const scrollAmount = 160; // Width of one card + gap
    const currentScroll = addMoreList.scrollLeft;
    
    if (direction === 'left') {
      addMoreList.scrollTo({
        left: currentScroll - scrollAmount,
        behavior: 'smooth'
      });
    } else if (direction === 'right') {
      addMoreList.scrollTo({
        left: currentScroll + scrollAmount,
        behavior: 'smooth'
      });
    }
    
  } catch (error) {
    console.error('❌ Error scrolling supplements:', error);
  }
}

// UI-specific function to update cart item count in header
function updateCartItemCount(supplementCount) {
  try {
    const cartItemCountElement = document.getElementById('cart-item-count');
    if (!cartItemCountElement) return;
    
    if (supplementCount === 0) {
      cartItemCountElement.textContent = 'Your cart is empty';
    } else {
      cartItemCountElement.textContent = `${supplementCount} item${supplementCount !== 1 ? 's' : ''} in your cart`;
    }
    
  } catch (error) {
    console.error('❌ Error updating cart item count:', error);
  }
}

// UI-specific function to update applied discounts display
function updateAppliedDiscounts() {
  try {
    const appliedDiscountsContainer = document.getElementById('applied-discounts');
    if (!appliedDiscountsContainer) return;
    
    // Get applied discounts from localStorage
    const appliedDiscounts = getAppliedDiscounts();
    const discountCodes = Object.keys(appliedDiscounts);
    
    // Clear existing discounts
    appliedDiscountsContainer.innerHTML = '';
    
    // Add each applied discount
    discountCodes.forEach(discountCode => {
      const discount = appliedDiscounts[discountCode];
      const discountItem = document.createElement('div');
      discountItem.className = 'cdp-applied-discount-item';
      discountItem.setAttribute('data-discount-code', discountCode);
      
      // Format discount display text with amount/percentage
      let discountDisplay = discountCode;
      
      if (discount.type === 'shipping') {
        discountDisplay = `${discountCode} (Free Shipping)`;
      } else if (discount.type === 'line_item') {
        if (discount.valueType === 'fixed_amount') {
          const savings = formatWithCurrency(window.Shopify?.currency, discount.value.toFixed(2));
          discountDisplay = `${discountCode} (-${savings})`;
        } else if (discount.valueType === 'percentage') {
          discountDisplay = `${discountCode} (-${discount.value}%)`;
        }
      }
      
      // Use title if available and different from code
      if (discount.title && discount.title !== discountCode) {
        if (discount.type === 'shipping') {
          discountDisplay = `${discount.title} (Free Shipping)`;
        } else if (discount.type === 'line_item') {
          if (discount.valueType === 'fixed_amount') {
            const savings = formatWithCurrency(window.Shopify?.currency, discount.value.toFixed(2));
            discountDisplay = `${discount.title} (-${savings})`;
          } else if (discount.valueType === 'percentage') {
            discountDisplay = `${discount.title} (-${discount.value}%)`;
          }
        }
      }
      
      // Get icon data from benefitsIcon dictionary for 'discount tag'
      const iconData = (typeof benefitsIcon !== 'undefined' && benefitsIcon['discount tag']) ? benefitsIcon['discount tag'] : null;
      const iconName = iconData ? iconData.icon : 'tag';
      const iconColor = iconData ? iconData.color : '#25D366';
      
      // Create discount code tag (same structure as benefit-tag)
      const discountTag = document.createElement('span');
      discountTag.className = 'solid-tag-icon';
      
      // Set CSS custom properties for colors
      discountTag.style.setProperty('--icon-color-20', iconColor + '33');
      discountTag.style.setProperty('--icon-color-40', iconColor + '66');
      discountTag.style.setProperty('--icon-color-70', iconColor + 'B3');
      discountTag.style.setProperty('--icon-color-100', iconColor);
      discountTag.style.setProperty('--icon-color', iconColor);
      
      // Create icon element
      const iconElement = document.createElement('i');
      iconElement.setAttribute('data-lucide', iconName);
      iconElement.className = 'icon';
      
      // Create text element
      const textElement = document.createElement('span');
      textElement.className = 'tag-text';
      textElement.textContent = discountDisplay;
      
      // Append icon and text to tag
      discountTag.appendChild(iconElement);
      discountTag.appendChild(textElement);
      
      // Create remove button
      const removeButton = document.createElement('button');
      removeButton.className = 'cdp-remove-discount';
      removeButton.setAttribute('onclick', `removeAppliedDiscount('${discountCode}', this)`);
      const removeIcon = document.createElement('i');
      removeIcon.setAttribute('data-lucide', 'x');
      removeIcon.className = 'icon';
      removeButton.appendChild(removeIcon);
      
      // Append remove button inside the tag
      discountTag.appendChild(removeButton);
      
      // Append discount tag to item
      discountItem.appendChild(discountTag);
      
      appliedDiscountsContainer.appendChild(discountItem);
    });
    
    // Initialize Lucide icons for new elements
    if (typeof lucide !== 'undefined' && lucide.createIcons) {
      lucide.createIcons();
    }
    
    // Recompute max-height of discount content to show applied discounts
    recomputeDiscountContentHeight();
    
    // Update discount count bubble
    updateDiscountCountBubble();
    

    
  } catch (error) {
    console.error('❌ Error updating applied discounts:', error);
  }
}

// UI-specific function to recompute discount content height
function recomputeDiscountContentHeight() {
  try {
    const discountSection = document.querySelector('.cdp-discount-section');
    const discountContent = document.querySelector('.cdp-discount-content');
    
    if (!discountSection || !discountContent) return;
    
    // Only recompute if the section is active (open)
    if (discountSection.classList.contains('active')) {
      // Temporarily set max-height to auto to measure content
      discountContent.style.maxHeight = 'auto';
      const contentHeight = discountContent.scrollHeight;
      
      // Set the new max-height
      discountContent.style.maxHeight = contentHeight + 'px';
      

    }
    
  } catch (error) {
    console.error('❌ Error recomputing discount content height:', error);
  }
}

// UI-specific function to update discount count bubble
function updateDiscountCountBubble() {
  try {
    const discountCountBubble = document.getElementById('discount-count-bubble');
    const discountCountNumber = document.getElementById('discount-count-number');
    
    if (!discountCountBubble || !discountCountNumber) return;
    
    // Get applied discounts from localStorage
    const appliedDiscounts = getAppliedDiscounts();
    const discountCount = Object.keys(appliedDiscounts).length;
    
    if (discountCount > 0) {
      // Show bubble and update number
      discountCountBubble.style.display = 'flex';
      discountCountNumber.textContent = discountCount;
    } else {
      // Hide bubble when no discounts
      discountCountBubble.style.display = 'none';
    }
    
    
    
  } catch (error) {
    console.error('❌ Error updating discount count bubble:', error);
  }
}

// UI-specific function to check discount and open discount section on first time
function checkDiscountAndFirstOpen() {
  try {
    // Check if a discount is applied
    const appliedDiscounts = getAppliedDiscounts();
    const discountCodes = Object.keys(appliedDiscounts);
    
    if (discountCodes.length === 0) {
     
      return;
    }
    
    // Check if discount section has already been opened (using sessionStorage)
    const discountSectionOpened = sessionStorage.getItem('discountSectionOpened');
    
    // Check if open_discount setting exists in localStorage
    const openDiscountSetting = localStorage.getItem('open_discount');
    
    // Determine if we should open: either first time OR localStorage flag is set
    const shouldOpen = discountSectionOpened !== 'true' || openDiscountSetting === 'true';
    
    if (!shouldOpen) {
     
      return;
    }
    
    // Determine the reason for opening
    const isFirstOpen = discountSectionOpened !== 'true';
    const hasLocalStorageFlag = openDiscountSetting === 'true';
    
    if (isFirstOpen && hasLocalStorageFlag) {
      //console.log('📝 Discount applied, first open, and open_discount flag found, will auto-open in 2 seconds');
    } else if (isFirstOpen) {
      //console.log('📝 Discount applied and section not yet opened, will auto-open in 2 seconds');
    } else if (hasLocalStorageFlag) {
      //console.log('📝 Discount applied and open_discount flag found, will auto-open in 2 seconds');
    }
    
    // Set a 2-second timer to open the discount section
    setTimeout(() => {
      try {
        // Check if discount section is not already open
        const discountSection = document.querySelector('.cdp-discount-section');
        if (discountSection && !discountSection.classList.contains('active')) {
          // Open the discount section
          const withAnimation = true;
          toggleDiscountSection(withAnimation);
         
        }
        
        // Set sessionStorage flag to indicate discount section has been opened
        sessionStorage.setItem('discountSectionOpened', 'true');
    
        
        // If localStorage open_discount flag was set, remove it after opening
        if (hasLocalStorageFlag) {
          localStorage.removeItem('open_discount');
         
        }
        
      } catch (error) {
        console.error('❌ Error auto-opening discount section:', error);
        // Still remove localStorage flag on error if it was set
        if (hasLocalStorageFlag) {
          localStorage.removeItem('open_discount');
        }
      }
    }, 2000); // 2-second delay
    
  } catch (error) {
    console.error('❌ Error checking discount and first open:', error);
  }
}
